import { render, staticRenderFns } from "./preview-testcase.vue?vue&type=template&id=c2701c26&"
import script from "./preview-testcase.ts?vue&type=script&lang=js&"
export * from "./preview-testcase.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports